export const SET_KIOSK_MODE = 'app/Features/SET_KIOSK_MODE';
export const SET_SHOW_EXIT_BUTTON = 'app/Features/SET_SHOW_EXIT_BUTTON';
